var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg069Trash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V7C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H16V4C16 2.34315 14.6569 1 13 1H11C9.34315 1 8 2.34315 8 4V5H4C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7ZM10 4C10 3.44772 10.4477 3 11 3H13C13.5523 3 14 3.44772 14 4V5H10V4ZM18 7H6V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V7ZM9 18C9.55228 18 10 17.5523 10 17V10C10 9.44771 9.55228 9 9 9C8.44772 9 8 9.44771 8 10V17C8 17.5523 8.44772 18 9 18ZM16 17C16 17.5523 15.5523 18 15 18C14.4477 18 14 17.5523 14 17V10C14 9.44771 14.4477 9 15 9C15.5523 9 16 9.44771 16 10V17Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg069Trash);
export default __webpack_public_path__ + "static/media/069-trash.ac85eb16ba117062bf0cd7505392d606.svg";
export { ForwardRef as ReactComponent };